import { Box, Group, Text } from "@mantine/core";
import { PATHOLOGIST_REVIEW_COLOR_LEGEND } from "./pathologistReviewQueueView";

export function PathologistQueueColorLegend() {
  return (
    <Group
      gap="md"
      wrap="wrap"
      role="group"
      aria-label="Pathologist work queue color key"
    >
      <Text size="xs" fw={600} c="dimmed">
        Row colors
      </Text>
      {PATHOLOGIST_REVIEW_COLOR_LEGEND.map((item) => (
        <Group key={item.key} gap={6} wrap="nowrap">
          <Box
            w={18}
            h={18}
            aria-hidden="true"
            style={{
              backgroundColor: item.background,
              border: "1px solid var(--mantine-color-gray-4)",
              borderRadius: "var(--mantine-radius-xs)",
            }}
          />
          <Text size="xs">{item.label}</Text>
        </Group>
      ))}
    </Group>
  );
}
